import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1025"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.491 9.369C8.9 9.022 7.742 7.659 7.742 5.976c0-1.682 1.473-2.579 1.473-2.579L7.249.76a.298.298 0 0 0-.464 0L4.286 4.11c-.125.167.008.391.232.391h1.151L3.065 7.994c-.179.24.012.563.334.563h.718l-2.75 3.54c-.256.33.018.774.478.774h4.409v1.757a.736.736 0 1 0 1.47 0v-1.757h4.409c.46 0 .734-.444.478-.774l-2.12-2.728z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.243 3.147c-.925.272-1.185 1.055-1.126 1.546-.66-.801-.708-1.725-.633-3.051-2.117.824-1.624 3.201-1.688 3.923-.532-.45-.633-1.525-.633-1.525-.561.297-.843 1.095-.843 1.742 0 1.565 1.26 2.705 2.775 2.705s2.711-1.141 2.711-2.705c-.001-.93-.641-1.237-.563-2.635z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }